import React from "react";
import { Link } from "react-router-dom";
import { getSitePageByPath } from "../../data/site-registry";

interface RelatedPagesProps {
  pathname: string;
}

export const RelatedPages: React.FC<RelatedPagesProps> = ({ pathname }) => {
  const page = getSitePageByPath(pathname);
  if (!page?.relatedPaths?.length) {
    return null;
  }

  const related = page.relatedPaths
    .map((path) => getSitePageByPath(path))
    .filter((entry): entry is NonNullable<typeof entry> => Boolean(entry));

  if (related.length === 0) {
    return null;
  }

  return (
    <nav aria-label="Weitere Seiten" className="mt-12 pt-8 border-t border-gray-200/60 dark:border-gray-700/40">
      <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Das könnte Sie auch interessieren</h2>
      <ul className="flex flex-wrap gap-3">
        {related.map((entry) => (
          <li key={entry.path}>
            <Link
              to={entry.path}
              className="inline-flex rounded-full px-4 py-2 text-sm font-medium text-ergo-700 bg-ergo-50 hover:bg-ergo-100 dark:text-ergo-300 dark:bg-ergo-900/40 dark:hover:bg-ergo-900/60 transition-colors"
            >
              {entry.label}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};
